import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { useSharedTranslation } from "@/shared/contexts/TranslateContext";

import IconView from "../IconView/IconView";

import { EXTERNAL_URLS, URLS } from "@/shared/utils/url/url";
import EgwWebFont from "../../assets/EgwWebFont";

import styles from "./Logotype.module.scss";

const Logotype = ({
  className,
  writingsTextClassName,
  text,
  isShowLogoWritingsLabel,
  isShowRegistered,
  isShowLogoLinks,
  scrollToTop,
  onClick,
}) => {
  const { t } = useSharedTranslation();

  const handleClickHome = (event) => {
    if (onClick) {
      onClick(event);
    }
    if (scrollToTop) {
      global.window.document.documentElement.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className={classnames(styles["logo-container"], className)}>
      <a
        href={URLS.home}
        className={styles["logo-top-container"]}
        tabIndex={0}
        aria-label={text ?? t("logo")}
        onClick={handleClickHome}
      >
        <span className={styles["logo-content"]}>
          <IconView icon={EgwWebFont.logo} className={styles["logo"]} alt="Ellen G. White Writings" />
          <span className={styles["logo-content-text"]}>
            {isShowLogoWritingsLabel && (
              <span className={classnames(styles["logo-content-app-name"], writingsTextClassName)}>
                {text ?? "writings"}
              </span>
            )}
            {isShowRegistered && <span className={styles["logo-content-copyright"]}>&reg;</span>}
          </span>
        </span>
      </a>
      {isShowLogoLinks && (
        <span className={styles["logo-container-links"]}>
          <a
            href={EXTERNAL_URLS.whiteEstate}
            className={styles["logo-link"]}
            target="_blank"
            rel="noopener noreferrer">
            whiteestate.org
          </a>{" "}
          |{" "}
          <a
            href={EXTERNAL_URLS.ellenWhite}
            className={styles["logo-link"]}
            target="_blank"
            rel="noopener noreferrer">
            ellenwhite.org
          </a>
        </span>
      )}
    </div>
  );
};

Logotype.defaultProps = {
  isShowRegistered: true,
};

Logotype.propTypes = {
  className: PropTypes.string,
  writingsTextClassName: PropTypes.string,
  Link: PropTypes.any,
  text: PropTypes.string,
  isShowLogoWritingsLabel: PropTypes.bool,
  isShowLogoLinks: PropTypes.bool,
  isShowRegistered: PropTypes.bool,
  scrollToTop: PropTypes.bool,
  onClick: PropTypes.func,
};

export default Logotype;
